export default __webpack_public_path__ + "images/a579ef1a78c15ea78044664e98021a58.png";